import {
  orgKycPresignRequestSchema,
  orgKycPresignResponseSchema,
  orgKycSubmissionSelfSchema,
  orgKycSubmitRequestSchema,
  orgKycSubmitResponseSchema,
  workerKycPresignRequestSchema,
  workerKycPresignResponseSchema,
  workerKycSubmissionSelfSchema,
  workerKycSubmitRequestSchema,
  workerKycSubmitResponseSchema,
  type OrgKycPresignRequest,
  type OrgKycSubmitRequest,
  type WorkerKycPresignRequest,
  type WorkerKycSubmitRequest,
} from "@chotca/config";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

export function createKycResource(ctx: RequestContext) {
  return {
    // Worker KYC (CCCD + selfie)
    getMyWorkerKyc() {
      return requestJson(ctx, {
        method: "GET",
        path: "/me/kyc",
        dataSchema: workerKycSubmissionSelfSchema.nullable(),
        auth: true,
      });
    },

    presignWorkerKyc(body: WorkerKycPresignRequest) {
      const payload = workerKycPresignRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: "/me/kyc/presign",
        body: payload,
        dataSchema: workerKycPresignResponseSchema,
        auth: true,
      });
    },

    submitWorkerKyc(body: WorkerKycSubmitRequest) {
      const payload = workerKycSubmitRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: "/me/kyc",
        body: payload,
        dataSchema: workerKycSubmitResponseSchema,
        auth: true,
      });
    },

    // Org KYC (tax code + business registration)
    getOrgKyc(orgId: string) {
      return requestJson(ctx, {
        method: "GET",
        path: `/orgs/${orgId}/kyc`,
        dataSchema: orgKycSubmissionSelfSchema.nullable(),
        auth: true,
      });
    },

    presignOrgKyc(orgId: string, body: OrgKycPresignRequest) {
      const payload = orgKycPresignRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: `/orgs/${orgId}/kyc/presign`,
        body: payload,
        dataSchema: orgKycPresignResponseSchema,
        auth: true,
      });
    },

    submitOrgKyc(orgId: string, body: OrgKycSubmitRequest) {
      const payload = orgKycSubmitRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: `/orgs/${orgId}/kyc`,
        body: payload,
        dataSchema: orgKycSubmitResponseSchema,
        auth: true,
      });
    },
  };
}
